import {
    Component,
    effect,
    EventEmitter,
    inject,
    input,
    Output,
    signal,
} from '@angular/core';
import Highcharts from 'highcharts';
import {
    DoughnutClickData,
    DoughnutData,
} from '../../../../_models/lakhpati-didi-dashboard.model';
import { PIE_CHART_OPTIONS } from '../../../dashboard/lakhpati-didi-dashboard/lakhpati-didi-dashboard.util';
import { IndianFormatPipe } from '../../_pipes/indian-format.pipe';

@Component({
    selector: 'lokos-doughnut-chart-dashboard',
    standalone: false,
    templateUrl: './doughnut-chart-dashboard.component.html',
    styleUrls: ['./doughnut-chart-dashboard.component.scss'],
})
export class DoughnutChartDashboardComponent {
    indianFormatPipe = inject(IndianFormatPipe);

    centerText = input<string>('');
    dataset = input.required<DoughnutData[]>();
    datasetColors = input.required<string[]>();
    legendData = input<string[]>();
    entity = input.required<string>();
    doughnutWidth = input<number>(300);
    doughnutHeight = input<number>(300);
    @Output() arcClick = new EventEmitter<DoughnutClickData>();

    // Doughnut Chart Variables
    chartOptions = signal<Highcharts.Options>({});
    updateFlag = false;

    constructor() {
        effect(() => {
            const data = this.dataset();
            this.updateChartData(data);
        });
    }

    updateChartData(data: DoughnutData[]) {
        const logData = data.map((item) => ({
            ...item,
            y: Math.sqrt(item.y),
            originalValue: item.y,
        }));
        const centralText = this.centerText();
        const datasetColors = this.datasetColors();
        const entity = this.entity();
        const basicChartConfig = PIE_CHART_OPTIONS(this.indianFormatPipe);

        this.chartOptions = signal<Highcharts.Options>({
            ...basicChartConfig,
            chart: {
                type: 'pie',
                animation: false,
                events: {
                    render() {
                        if (centralText) {
                            const label = (this as any).__centerLabel__;

                            const cx = this.plotLeft + this.plotWidth / 2;
                            const cy = this.plotTop + this.plotHeight / 2;

                            if (label && typeof label.attr === 'function') {
                                label.attr({ x: cx, y: cy });
                            } else {
                                const newLabel = this.renderer
                                    .text(centralText, cx, cy)
                                    .attr({ 'text-anchor': 'middle' })
                                    .css({
                                        fontSize: '22px',
                                        fontWeight: '600',
                                        color: '#1D1F2C',
                                        pointerEvents: 'none',
                                    })
                                    .add();
                                (this as any).__centerLabel__ = newLabel;
                            }
                        }
                    },
                },
            },
            plotOptions: {
                pie: {
                    borderRadius: 12,
                    innerSize: '50%',
                    borderWidth: 10,
                    startAngle: 90,
                    dataLabels: { enabled: false },
                    point: {
                        events: {
                            click: (event) => {
                                const point = event.point;

                                this.onChartClick({
                                    entity: entity,
                                    label: point.name,
                                    dataValue: point.y,
                                    dataIndex: point.index,
                                });
                            },
                        },
                    },
                },
            },
            series: [
                {
                    type: 'pie',
                    showInLegend: true,
                    name: 'Distribution',
                    colors: datasetColors,
                    data: logData,
                    states: {
                        inactive: {
                            enabled: false,
                        },
                        hover: {
                            enabled: false,
                        },
                    },
                },
            ],
        });
        this.updateFlag = true;
    }

    onChartClick(payload: DoughnutClickData) {
        this.arcClick.emit(payload);
    }
}
